import { HOW_IT_WORKS_STEPS } from '../data';

export function HowItWorksSection() {
  return (
    <section className="bg-white">
      <div className="section-container py-10 sm:py-12">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
          How It Works
        </p>

        <h2 className="mt-5 max-w-xl text-3xl font-semibold leading-[1.1] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Three steps. No card on file until you&rsquo;re sure.
        </h2>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-500 sm:text-lg">
          The bootcamp is structured so you can try the whole experience first &mdash; full
          classes, full instructor, full curriculum &mdash; and only continue if your child is
          loving it.
        </p>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {HOW_IT_WORKS_STEPS.map((step) => (
            <div key={step.number} className="relative pt-5">
              <span className="absolute left-7 top-0 z-10 flex size-10 items-center justify-center rounded-full bg-brand-600 text-sm font-bold text-white shadow-md">
                {step.number}
              </span>
              <div className="flex h-full flex-col rounded-2xl bg-white p-7 pt-10 shadow-sm ring-1 ring-slate-200/60">
                <h3 className="mt-2 text-lg font-semibold text-slate-900">
                  {step.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">
                  {step.description}
                </p>
                <span className="mt-5 inline-flex w-fit rounded-full bg-[#EEF2FE] px-4 py-1.5 text-sm font-medium text-[#0E1726]">
                  {step.badge}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}